import { isEmpty } from 'lodash-es';
import { useMemo } from 'react';

import { normalizePieData } from '../utils/normalize-pie-data.js';
import type { NormalizePieDataInput } from '../utils/normalize-pie-data.js';

export interface NormalizedPieData {
  normalizedData: ReturnType<typeof normalizePieData>;
  isDataAvailable: boolean;
}

export function useNormalizedPieData({
  data,
  labelAccessor,
  valueAccessor,
  unit,
}: NormalizePieDataInput): NormalizedPieData {
  const normalizedData = useMemo(
    () => normalizePieData({ data, labelAccessor, valueAccessor, unit }),
    [data, labelAccessor, valueAccessor, unit],
  );

  const isDataAvailable =
    normalizedData.slices !== undefined
      ? !isEmpty(normalizedData.slices)
      : !isEmpty(data);

  return { normalizedData, isDataAvailable };
}
